import { FC } from "react";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { FeatureUpgradeModal } from "@components/billing/FeatureUpgradeModal";

interface Props {
    readonly show: boolean;
    readonly onHide: () => void;
}

export const MultiEntityUpgradeModal: FC<Props> = ({ show, onHide }) => (
    <FeatureUpgradeModal
        show={show}
        onHide={onHide}
        plan={FLAT_RATE_PLANS.PLUS}
        text={
            <>
                Multi-entity is available on{" "}
                <span className="text-blue-600">Plus</span>
            </>
        }
        description={
            <>
                Create and manage unlimited entities in the same workspace to
                automate intercompany reconciliation and multi-entity workflows.
            </>
        }
    />
);
